import * as imageApi from '../../api/image'

async function deleteImage({ dispatch }) {
  await imageApi.deleteImage()
  dispatch('notify', { newNotification: { type: 'success', message: 'Kép törlése sikeres!' } })
}

async function createImage({ dispatch }, formData) {
  await imageApi.createImage(formData)
  dispatch('notify', { newNotification: { type: 'success', message: 'Kép feltöltése sikeres!' } })
}

const imageStore = {
  actions: {
    deleteImage,
    createImage
  }
}

export default imageStore
